<template>
  <div>
    <v-dialog v-model="showDialog" max-width="450px" persistent>
      <v-card class="px-5 py-10" rounded="lg">
        <v-card-text>
          <slot>
            <h2 class="text-center mb-5 pb-5">Do you want to delete text replacement key {{ key }}?</h2>
          </slot>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Confirm Btn -->
          <v-btn
            rounded
            depressed
            color="primary"
            width="100px"
            class="mx-3"
            @click="confirm()"
          >
            Delete
          </v-btn>

          <v-btn
            rounded
            depressed
            color="secodary"
            width="100px"
            class="mx-3"
            @click="closeModal()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMessage" max-width="400px" persistent>
      <v-card class="px-5 py-10" rounded="lg">
        <v-card-text>
          <slot>
            <h2 class="text-center">
              Text Replacement deleted
            </h2>
          </slot>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Confirm Btn -->
          <v-btn rounded depressed color="primary" width="100px" class="mx-3" @click="showMessage = false;">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
export default {
  name: 'TextReplacementDeleteDialog',
  props: ['showDialog'],
  data() {
    return {
      id: 0,
      key: '',
      showMessage: false
    }
  },
  methods: {
    init (id, key) {
      this.id = id;
      this.key = key;
    },
    closeModal() {
      this.$parent.showDeleteDialog = false;
    },
    async confirm () {
      await this.$store.dispatch("textreplacement/deleteTextReplacement", {id: this.id});
      this.$parent.searchText();
      this.$parent.showDeleteDialog = false;
      this.showMessage = true;
      this.$store.dispatch('textreplacement/fetchFullTextReplacements');
    }
  }

}
</script>